import * as React from 'react';
import { useOrganizationBriefQuery, type OrganizationBrief } from '@/hooks/useAgentCurrency.js';

/**
 * The agents this operator may hand a new row to.
 *
 * The brand list is already scoped by the gateway, so it is the caller's own
 * subtree — one agent for a brand operator, every agent for the platform root.
 * Only `kind === 'agent'` rows can own anything: the money tables are keyed on
 * agent ids, and a senior or master node id in that column matches nothing.
 *
 * Shared with `useAgentCurrency`, so the currency lookup and every
 * `AgentSelect` on the page ride the same cached response.
 */
export function useOwnableAgents(): {
  agents: OrganizationBrief[];
  isLoading: boolean;
  isError: boolean;
} {
  const { data, isLoading, isError } = useOrganizationBriefQuery();

  const agents = React.useMemo(
    () => (data?.items ?? []).filter((o) => o.kind === 'agent' && o.status === 'active'),
    [data],
  );

  return { agents, isLoading, isError };
}

